/* eslint-disable @typescript-eslint/no-unused-vars */
import { AuthConfigs } from 'Utils/auth/authConfigs';
import { MainRoutes } from 'Utils/routes/constants';
export var Access;
(function (Access) {
    Access[Access["Forbidden"] = 0] = "Forbidden";
    Access[Access["Allowed"] = 1] = "Allowed";
})(Access || (Access = {}));
class AlwaysForbidden {
    checkRoute(path) {
        return Access.Forbidden;
    }
}
export const alwaysForbidden = new AlwaysForbidden();
class AlwaysAllowed {
    checkRoute(path) {
        return Access.Allowed;
    }
}
export const alwaysAllowed = new AlwaysAllowed();
const ROUTES_RE = new RegExp(`/(${MainRoutes.MONITORING}).*`);
export const ROUTE_RULES = [
    { path: '/', access: Access.Allowed },
    { role: 'Administrators', pathRe: /.*/, access: Access.Allowed },
    { role: 'DataScientist', pathRe: ROUTES_RE, access: Access.Allowed },
    { role: 'Users', pathRe: ROUTES_RE, access: Access.Allowed }
];
export class RolesAuthorizationChecker {
    roles;
    routeRules;
    constructor(routeRules) {
        this.routeRules = routeRules;
    }
    matchPath(rule, path) {
        if (rule.path) {
            return rule.path === path;
        }
        if (rule.pathPrefix) {
            return path.indexOf(rule.pathPrefix) === 0;
        }
        if (rule.pathRe) {
            return rule.pathRe.test(path);
        }
        return false;
    }
    extractRolesFromAccount(account) {
        const idTokenClaims = account?.idTokenClaims;
        return idTokenClaims?.roles ?? [];
    }
    checkRoute(path, account) {
        const roles = this.extractRolesFromAccount(account);
        for (const i in this.routeRules) {
            const rule = this.routeRules[i];
            if (this.matchPath(rule, path)) {
                if (!rule.role || roles.indexOf(rule.role) > -1) {
                    return rule.access;
                }
            }
        }
        return Access.Forbidden;
    }
}
export const createAuthorizationChecker = () => {
    if (!AuthConfigs.IS_DEV_ENV) {
        return new RolesAuthorizationChecker(ROUTE_RULES);
    }
    return alwaysAllowed;
};
